import * as React from "react";
import * as ReactDOM from "react-dom";
export interface ProgressBarControlProps extends React.Props<ProgressBarControl> {
    loading?: boolean
}

// TODO: unify with ProgressRingControl since the html structures are pretty much the same    
export class ProgressBarControl extends React.Component<ProgressBarControlProps, any> {
    constructor(props: ProgressBarControlProps) {
        super(props);
    }
       
    public render(): JSX.Element {
        let className = "loading-animation progress-bar";
        if (this.props.loading) {
            className = `${className} loading`;
        }
        return (
            <div className={className}>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
            </div>
            ); 
    }
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/ProgressBarControl.tsx